import { useCallback } from 'react';
import { useQuery } from 'react-query';
import { request, useCurrentUserId } from '@/utils';

import { Badge, OfficialBadge, UnionBadge } from '../types';
import { transBadge } from '../utils';

export const useBadgeList = (start = 0) => {
  const currentAddress = useCurrentUserId();
  const url = '/badge/list';

  const select = useCallback(
    ({ badge_list }: { badge_list: Array<Badge & { has_minted: boolean }> }) => {
      badge_list.forEach(transBadge);

      return badge_list;
    },
    [],
  );

  return useQuery(
    [url, currentAddress, start],
    () => request.get<{ badge_list: Array<Badge & { has_minted: boolean }> }>(url),
    {
      select,
    },
  );
};

export const useAllBadgeList = () => {
  const currentAddress = useCurrentUserId();
  const select = useCallback(
    (res: Array<{ badge_list: Array<UnionBadge & { has_minted: boolean }> }>) => {
      const list = res.reduce(
        (prv, cur) => {
          prv = [...prv, ...cur.badge_list];
          return prv;
        },
        [] as Array<UnionBadge & { has_minted: boolean }>,
      );
      return list.map(transBadge).sort((a, b) => b.create_at - a.create_at) as Array<
        UnionBadge & { has_minted: boolean }
      >;
    },
    [],
  );
  return useQuery(
    ['all-badgeList', currentAddress],
    () =>
      Promise.all([
        request.get<{ badge_list: Array<Badge & { has_minted: boolean }> }>('/badge/list'),
        request.get<{ badge_list: Array<OfficialBadge & { has_minted: boolean }> }>(
          '/official_badge/list',
        ),
      ]),
    {
      select,
    },
  );
};
